import { render } from "./PendingItems.vue?vue&type=template&id=97d5cd0a&scoped=true"
import script from "./PendingItems.vue?vue&type=script&lang=js"
export * from "./PendingItems.vue?vue&type=script&lang=js"

import "./PendingItems.vue?vue&type=style&index=0&id=97d5cd0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d5cd0a"]])

export default __exports__